import React, { useEffect, useState } from "react";
import { FxLabelBase } from "../../fxms/inputs/FxLabel";
import { FxTextFieldBase } from "../../fxms/inputs/FxTextField";
import { FxFileLink } from "../../fxms/inputs/FxFileLink";

/*정비이력 > 상세 화면*/
export const UI_3_1_CU = (props) => {
  const [selectedData, setSelectedData] = React.useState({});
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedUploadedFiles, setSelectedUploadedFiles] = useState([]);

  // 날짜 형식을 YYYY-MM-DD로 변환하는 함수 추가
  const formatDateToDisplay = (dateString) => {
    if (!dateString) return '';
    return dateString.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
  };

  useEffect(() => {    

    console.log("UI_3_1_CU", props); 
    setSelectedUploadedFiles(props.selectedData.files);
    setSelectedData({
      ...props.selectedData,
      fpactStrtDate: formatDateToDisplay(props.selectedData.fpactStrtDate),
      fpactEndDate: formatDateToDisplay(props.selectedData.fpactEndDate)
    });

  }, [selectedFiles]);
  
  return (
    <div style={{ height: '100%', overflow: 'hidden' }}>
      <div className="FxDataEdit">
        <table className="table">
        <colgroup>
            <col style={{ width: '100px' }} />
            <col style={{ width: '300px' }} />
            <col style={{ width: '100px' }} />
            <col style={{ width: '300px' }} />
          </colgroup>
          <tr>
            <th><FxLabelBase>알림발생 관리번호</FxLabelBase></th>
            <td><FxTextFieldBase name="alarmNo" selectedData={selectedData} disabled={true} /></td>
            <th><FxLabelBase>산업단지명</FxLabelBase></th>
            <td><FxTextFieldBase name="complexName" selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>회사명</FxLabelBase></th>
            <td><FxTextFieldBase name="companyName" selectedData={selectedData} disabled={true} /></td>
            <th><FxLabelBase>사업장명</FxLabelBase></th>
            <td><FxTextFieldBase name="plantName" selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>알람유형</FxLabelBase></th>
            <td colSpan="1"><FxTextFieldBase name="alarmClCd" selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>설비명</FxLabelBase></th>
            <td><FxTextFieldBase name="facName" selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>설비번호</FxLabelBase></th>
            <td><FxTextFieldBase name="facNo" selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>조치내용</FxLabelBase></th>
            <td colSpan="1"><FxTextFieldBase name="fpactCnt" selectedData={selectedData} disabled={true} /></td>
          </tr>
          <tr>
            <th><FxLabelBase>조치시작일</FxLabelBase></th>
            <td>
              <input 
                className="FxDate" 
                type="date" 
                name="alarmFpactStrtDate" 
                value={selectedData.fpactStrtDate} 
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <th><FxLabelBase>조치종료일</FxLabelBase></th>
            <td>
              <input 
                className="FxDate" 
                type="date" 
                name="alarmFpactEndDate" 
                value={selectedData.fpactEndDate} 
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <th><FxLabelBase>첨부</FxLabelBase></th>
            <td>
              {selectedUploadedFiles?.map((item)=> (
                  <span key={item.fileId}> <FxFileLink fileId={item.fileId} fileUrl={'3_3'} orgNm={item.name}></FxFileLink> </span>
            ))}
            </td>
          </tr> 
        </table>
      </div>
    </div>
  )
}
